module.exports = __webpack_public_path__ + "img/Lentes.cb9a84ae.png";